<template>
  <div class="mx-auto flex w-full flex-col gap-6">
    <div class="flex flex-col gap-1">
      <h1 class="text-3xl font-bold tracking-tight">
        Tasks
      </h1>
      <p class="text-sm text-muted-foreground">
        Manage operational tasks, reusable templates, and data buckets.
      </p>
    </div>

    <Tabs :model-value="activeTab" class="w-full" @update:model-value="onTabChange">
      <TabsList class="grid w-full grid-cols-3">
        <TabsTrigger v-for="tab in tabs" :key="tab.value" :value="tab.value">
          {{ tab.label }}
        </TabsTrigger>
      </TabsList>
    </Tabs>

    <router-view />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Tabs, TabsList, TabsTrigger } from '../../../../../../resources/js/components/ui/tabs/index.js'

const tabs = [
  { value: 'tasks', label: 'Tasks', routeName: 'TasksTabTasksPage' },
  { value: 'templates', label: 'Task Templates', routeName: 'TasksTabTemplatesPage' },
  // { value: 'buckets', label: 'Task Buckets', routeName: 'TasksTabBucketsPage' },
]

const routeNameToTabValue = {
  TasksTabTasksPage: 'tasks',
  TasksTabTemplatesPage: 'templates',
  TasksTabBucketsPage: 'buckets',
}

const route = useRoute()
const router = useRouter()

const activeTab = computed(() => {
  return routeNameToTabValue[route.name] ?? 'tasks'
})

const onTabChange = (tabValue) => {
  const targetTab = tabs.find((tab) => tab.value === tabValue)

  if (!targetTab || route.name === targetTab.routeName) {
    return
  }

  router.push({ name: targetTab.routeName })
}
</script>
